import React from 'react';
import SuperWeekCompare from './SuperWeekCompare';

export default function BranchWeekCompare() {
  return <SuperWeekCompare branchScoped={true} />;
}
